import { memo } from 'react'

import { Avatar, Box, Text } from '@chakra-ui/react'

import { TeamMember } from '@pkg/types/team'

interface TeamMemberItemProps {
  member: TeamMember
  onSelect: (memberId: string) => void
  isFirst?: boolean
  isLast?: boolean
}

export const TeamMemberItem = memo(
  ({ member, onSelect, isFirst, isLast }: TeamMemberItemProps) => {
    return (
      <Box
        px={4}
        py={2.5}
        cursor="pointer"
        bg="white"
        _hover={{ bg: '#f6f6f6' }}
        pt={isFirst ? 3.5 : 2.5}
        pb={isLast ? 3.5 : 2.5}
        onClick={() => onSelect(member.id)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onSelect(member.id)
          }
        }}
        transition="all 0.2s"
        role="option"
        tabIndex={0}
        aria-selected={false}
        aria-label={`${member.displayName}, ${member.email}`}
        display="flex"
        alignItems="center"
        gap={3}
      >
        <Avatar size="sm" name={member.displayName} src={member.photoURL} />
        <Box flex="1">
          <Text fontWeight="bold">{member.displayName}</Text>
          <Text fontSize="xs" color="gray.600" mt={0.5}>
            {member.email}
          </Text>
        </Box>
      </Box>
    )
  },
)

TeamMemberItem.displayName = 'TeamMemberItem'
